import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=7d024ddd&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=7d024ddd&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d024ddd",
  null
  
)

export default component.exports